<template>
  <loadprogress ref="loadprogressRef" v-if="isLoading"/>
</template>

<script setup>
import { ref, nextTick, createVNode, defineProps } from 'vue'
import { ElMessageBox } from 'element-plus'
import loadprogress from '@/components/common/loadprogress.vue'

const props = defineProps({
  type: String,
  options: Object
})

const url = 'https://bigdata.topeti.com/PCRepository/mainPlatform/'
const isLoading = ref(false)
const loadprogressRef = ref(null)

const statusObj = {
  success: {
    icon: 'success.png',
    title: '操作成功',
    titleColor: '#169D4E'
  },
  error: {
    icon: 'error.png',
    title: '操作失败',
    titleColor: '#D44C4C'
  },
  warning: {
    icon: 'warning.png',
    title: '警告',
    titleColor: '#E6A23C'
  }
}

// 根据类型执行对应的方法
const init = async () => {
  const funMap = {
    message: messageFun,
    statusMsg: statusMsgFun,
    loadingMsg: loadingMsgFun
  }
  
  const fun = funMap[props.type]
  if (fun) {
    await fun(props.options)
  }
}

// 立即执行
init()

function messageFun(val) {
  const h = createVNode;
  const defaultsStyle = h('p', null, [
    h('i', { class: val.iconType, style: 'margin-right:8px;' }, ''),
    h('span', null, val.title)
  ])
  
  ElMessageBox({
    message: val.message || defaultsStyle,
    showCancelButton: val.showCancelButton || false,
    confirmButtonText: val.confirmButtonText || '',
    cancelButtonText: '取消'
  }).then(action => {
    if (val.confirmFun) val.confirmFun(action)
  }).catch(err => {
    if (val.confirmFun) val.confirmFun(err)
  })
}

function statusMsgFun(val) {
  const h = createVNode;
  const defaultsStyle = h('div', { style: { textAlign: 'center' } }, [
    h('img', {
      src: url + statusObj[val.status].icon,
      style: { width: '99px', height: '91px' }
    }, 'sdf'),
    h('div', {
      style: { color: statusObj[val.status].titleColor, paddingTop: '28px', fontSize: '16px' }
    }, val.title || statusObj[val.status].title)
  ])
  
  ElMessageBox({
    title: '',
    message: val.message || defaultsStyle,
    showConfirmButton: false,
    showCancelButton: true,
    cancelButtonText: val.confirmButtonText,
    cancelButtonClass: 'msgCloseClass',
    center: true,
    customClass: 'custMsgCloseClass'
  }).then(action => {
    if (val.confirmFun) val.confirmFun(action)
  }).catch(err => {
    if (val.confirmFun) val.confirmFun(err)
  })
}

async function loadingMsgFun(val) {
  isLoading.value = true
  await nextTick()
  
  if (loadprogressRef.value) {
    const obj = {
      isShow: true,
      text: val.additionalTips
    };
    if (val.schedule || val.schedule === 0) obj.schedule = val.schedule;
    loadprogressRef.value.fromParent(obj);
    if (val.confirmFun) val.confirmFun(loadprogressRef.value)
  }
}
</script>

<style lang="scss">
.custMsgCloseClass {
  padding-bottom: 20px;
  width: 320px;
  .el-message-box__content {
    padding-top: 0;
  }
  .el-message-box__header {
    padding-top: 20px;
    .el-message-box__headerbtn {
      top: 10px;
    }
  }
  .msgCloseClass {
    width: 88px;
  }
}
</style>